import { ErrorReason, ErrorStatus } from '@tink/core/src/tinkLinkErrorCodes';
import { ApplicationError } from '../../../components/ApplicationErrorBoundary/errors/ApplicationError';
import { ResponseObj } from '../../../lib-api/services/base';
import { IncomeCheckResponse } from '../models/incomeCheck';
import { CreateIncomeCheckPayload, triggerCheck } from './income-check-client';

export interface IncomeCheckClient {
  createReport: (
    payload: CreateIncomeCheckPayload
  ) => Promise<ResponseObj<IncomeCheckResponse | undefined>>;
}

export interface IncomeCheckService {
  createReport: (payload: CreateIncomeCheckPayload) => Promise<IncomeCheckResponse>;
}

const incomeCheckClient: IncomeCheckClient = {
  createReport: triggerCheck,
};

export const ERR_INCOME_CHECK_FAILED_CREATE_REPORT = {
  errorStatus: ErrorStatus.INTERNAL_ERROR,
  errorReason: ErrorReason.REQUEST_FAILED_CREATE_INCOME_CHECK_REPORT,
};

export function createIncomeCheckService(client: IncomeCheckClient): IncomeCheckService {
  return {
    createReport: async (payload) => {
      const response = await client.createReport(payload);

      if (response.isOk() && response.data) {
        return response.data;
      }
      throw new ApplicationError(ERR_INCOME_CHECK_FAILED_CREATE_REPORT);
    },
  };
}

export const incomeCheckService = createIncomeCheckService(incomeCheckClient);
